import { useEffect, useState } from "react";
import api from "../lib/api";
import { Plus, Trash2, Calendar as CalendarIcon } from "lucide-react";
import { toast } from "sonner";

export default function Planning() {
  const [posts, setPosts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    account_id: "", title: "", caption: "", hook: "",
    platform: "instagram", format: "reel",
    scheduled_at: new Date().toISOString().slice(0, 16),
    status: "planifie", notes: ""
  });

  const load = async () => {
    const [p, a] = await Promise.all([api.listPosts(), api.listAccounts()]);
    setPosts(p); setAccounts(a);
    if (a.length && !form.account_id) setForm(f => ({ ...f, account_id: a[0].id }));
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await api.createPost(form);
    toast.success("Post planifié");
    setShowForm(false);
    setForm({ ...form, title: "", caption: "", hook: "", notes: "" });
    load();
  };

  const del = async (id) => { await api.deletePost(id); load(); };

  // group by date
  const grouped = {};
  posts.sort((a, b) => a.scheduled_at.localeCompare(b.scheduled_at)).forEach(p => {
    const d = p.scheduled_at.slice(0, 10);
    if (!grouped[d]) grouped[d] = [];
    grouped[d].push(p);
  });

  return (
    <div className="space-y-8 animate-fadeUp" data-testid="planning-page">
      <header className="flex items-end justify-between flex-wrap gap-4">
        <div className="border-l-2 border-[#CCFF00] pl-5">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// OPÉRATIONS</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">Planning Publication</h1>
          <p className="text-zinc-400 mt-2">Pipeline visible. Pas de poste oublié, pas de surcharge.</p>
        </div>
        <button onClick={() => setShowForm(s => !s)} data-testid="add-post-btn"
          className="bg-[#CCFF00] text-black font-medium px-5 py-2.5 rounded-sm hover:bg-[#B3E600] glow-volt flex items-center gap-2 text-sm">
          <Plus className="w-4 h-4" /> Planifier un post
        </button>
      </header>

      {showForm && (
        <form onSubmit={submit} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6 space-y-3 grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="post-form">
          <select required value={form.account_id} onChange={e => setForm({ ...form, account_id: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="">— Compte —</option>
            {accounts.map(a => <option key={a.id} value={a.id}>{a.label} ({a.handle})</option>)}
          </select>
          <input required value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
            placeholder="Titre du post" className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <input value={form.hook} onChange={e => setForm({ ...form, hook: e.target.value })}
            placeholder="Hook" className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <select value={form.platform} onChange={e => setForm({ ...form, platform: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="instagram">Instagram</option><option value="tiktok">TikTok</option>
            <option value="threads">Threads</option><option value="x">X</option><option value="youtube">YT Shorts</option>
          </select>
          <select value={form.format} onChange={e => setForm({ ...form, format: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="reel">Reel</option><option value="post">Post</option>
            <option value="story">Story</option><option value="carousel">Carousel</option>
            <option value="short">Short</option>
          </select>
          <input type="datetime-local" required value={form.scheduled_at}
            onChange={e => setForm({ ...form, scheduled_at: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="brouillon">Brouillon</option><option value="planifie">Planifié</option>
            <option value="publie">Publié</option><option value="annule">Annulé</option>
          </select>
          <textarea value={form.caption} onChange={e => setForm({ ...form, caption: e.target.value })}
            placeholder="Caption" rows={2} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white md:col-span-2" />
          <div className="md:col-span-2 flex gap-2">
            <button type="submit" data-testid="submit-post" className="bg-[#CCFF00] text-black px-5 py-2 rounded-sm font-medium text-sm">Enregistrer</button>
            <button type="button" onClick={() => setShowForm(false)} className="border border-[#1E1E24] text-zinc-400 px-5 py-2 rounded-sm text-sm">Annuler</button>
          </div>
        </form>
      )}

      <div className="space-y-6">
        {Object.keys(grouped).length === 0 ? (
          <div className="border border-dashed border-[#1E1E24] rounded-sm p-12 text-center">
            <CalendarIcon className="w-10 h-10 text-zinc-700 mx-auto mb-3" strokeWidth={1.2} />
            <div className="text-zinc-500 text-sm">Aucun post planifié. Commence avec le bouton "Planifier un post".</div>
          </div>
        ) : Object.entries(grouped).map(([date, items]) => (
          <div key={date}>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-3 border-b border-[#1E1E24] pb-2">
              {new Date(date).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
            </div>
            <div className="space-y-2">
              {items.map(p => {
                const acc = accounts.find(a => a.id === p.account_id);
                return (
                  <div key={p.id} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-4 flex items-center gap-4 hover:border-white/20" data-testid={`post-row-${p.id}`}>
                    <div className="font-mono text-xs text-[#CCFF00] w-16">{p.scheduled_at.slice(11, 16)}</div>
                    <div className="flex-1 min-w-0">
                      <div className="text-white text-sm font-medium truncate">{p.title}</div>
                      <div className="text-xs text-zinc-500 font-mono uppercase tracking-wider mt-0.5">
                        {acc?.label || "—"} · {p.platform} · {p.format}
                      </div>
                    </div>
                    <span className="text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-sm border" style={{
                      color: p.status === "publie" ? "#10B981" : p.status === "annule" ? "#EF4444" : "#CCFF00",
                      borderColor: p.status === "publie" ? "#10B98140" : p.status === "annule" ? "#EF444440" : "#CCFF0040",
                    }}>{p.status}</span>
                    <button onClick={() => del(p.id)} className="text-zinc-600 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
